import { EFilterKeys, SelectedFilter } from './domains/CollectionFilter'

export function stripSubcollectionValuesFromSelectedFilter(selectedFilter: SelectedFilter): SelectedFilter {
  const selectedSubcollections = SelectedFilter.getSelectedFilterValuesByFilterName(
    selectedFilter,
    EFilterKeys.SUBCOLLECTIONS,
  )

  if (selectedSubcollections.length === 0) {
    return selectedFilter
  }

  return SelectedFilter.removeAllValuesFromSelectedFilter(selectedFilter, EFilterKeys.SUBCOLLECTIONS)
}

function stripFilterParam({
  searchParams,
  key,
  parse,
  serialize,
}: {
  searchParams: URLSearchParams
  key: 'filter' | 'filters'
  parse: (value: string) => SelectedFilter
  serialize: (selectedFilter: SelectedFilter) => string
}): void {
  const currentValue = searchParams.get(key)
  if (!currentValue) {
    return
  }

  const updatedValue = serialize(stripSubcollectionValuesFromSelectedFilter(parse(currentValue)))
  if (updatedValue) {
    searchParams.set(key, updatedValue)
    return
  }

  searchParams.delete(key)
}

export function stripSubcollectionQueryFilters(searchParams: URLSearchParams): void {
  stripFilterParam({
    searchParams,
    key: 'filter',
    parse: value => SelectedFilter.getSelectedFilterFromQueryParams(value),
    serialize: selectedFilter => SelectedFilter.getUpdatedSelectedFilterStringForWindowURL(selectedFilter),
  })
  stripFilterParam({
    searchParams,
    key: 'filters',
    parse: value => SelectedFilter.getSelectedFilterFromQueryParamsV2(value),
    serialize: selectedFilter => SelectedFilter.getUpdatedSelectedFilterStringForWindowURLV2(selectedFilter),
  })
}
